/**
 * Ex: expires: 30 * DAY
 */

export var SECOND = 1000;
export var MINUTE = 60 * SECOND;
export var HOUR = 60 * MINUTE;
export var DAY = 24 * HOUR;
export var STANDARD_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ssZZ';